import { useState } from "react";

import { ProductController, UserController } from "controllers";

const FlagItemButton = ({ customer, box, item }) => {
    const [isFlagged, setFlagged] = useState(item.flagged ?? false);

    const handleClick = async () => {
        if (!window.confirm(`Are you sure you want to flag that garment ${item.barcode}?`)) {
            return;
        }

        const payload = { flagged: true }
        await UserController.updateUserBoxItemByID(customer.id, box.id, item.id, payload);
        await ProductController.updateProductFields({ barcode: item.barcode, payload });
        setFlagged(true);
    }

    return (
        <small>
            <span className={`icon-text ${isFlagged ? '' : 'is-clickable'}`} onClick={handleClick}>
                <span className="icon has-text-danger">
                    <i className="fas fa-flag"></i>
                </span>
                <span className="is-hidden-mobile">
                    {isFlagged ? 'Flagged!' : 'Flag it'}
                </span>
            </span>
        </small>
    );
}

export { FlagItemButton };
